<div class="titulo-div " [style.background]="backgroudColor" #start>
  <div>

  </div>


</div>


<div class="planEstudio-div">
  <div class="izq" #izq>
    <div #izqContent>
      <ng-container *ngFor="let item of planData; let i = index">
        <div (click)="onSelectItem(i)" [ngClass]="{ 'item-activo': (selectedItemIndex === i)  }" class="item-estudio"
          [style.background-color]="selectedItemIndex === i ? backgroudColor : null">
          <span class="mas quicksand-bold">+</span>
          <span class="quicksand-bold item-titulo">{{ item.title }}</span>
        </div>
      </ng-container>

      <!--<div class="mb-3">
        <button class="btn-entrevista nunito-medium" (click)="openModal()">RECIBÍ MÁS INFORMACIÓN</button>
      </div>-->

      <div style="position: relative;  width: 100%; margin-top: 20px;" class="desk">

        <!-- Vista previa -->
        <div style="position: relative;">
          <!-- <div (click)="expand()"  class="pointer" [innerHTML]="html" ></div>-->
          <div (click)="expand()" class="pointer div-img-expand">
            <div [innerHTML]="image" *ngIf="image"></div>
            <img src="./assets/img/flyer-plan-curso.jpg" *ngIf="!image">

          </div>
          <button (click)="expand()" class="expand-btn" aria-label="Expandir contenido">
            <img src="./assets/img/arrows_output.png" alt="expandir">
          </button>
        </div>

        <!-- Modal de pantalla completa -->
        <div class="html-modal" *ngIf="isModalOpen">
          <div class="html-content-wrapper" (wheel)="zoom($event)" (mousedown)="startDrag($event)"
            (mousemove)="onDrag($event)" (mouseup)="endDrag()" (mouseleave)="endDrag()" [ngStyle]="{
         'transform': 'scale(' + scale + ') translate(' + translateX + 'px,' + translateY + 'px)',
         'cursor': isDragging ? 'grabbing' : 'grab'
       }">
            <!-- <div [innerHTML]="html"></div> -->
            <div class="pointer ">
              <div [innerHTML]="image" *ngIf="image"></div>
              <img src="./assets/img/flyer-plan-curso.jpg" *ngIf="!image">

            </div>
          </div>

          <button class="close-btn2" (click)="close(); $event.stopPropagation()">x</button>
        </div>
      </div>
    </div>

  </div>

  <div class="derecha">
    <!-- <h2 class="tituloBody nunito-bold">{{titlehtml | uppercase}}</h2> -->
    <div class="content-wrapper" [class.expanded]="expanded" #contentWrapper>
      <div *ngIf="htmlsanitizado" [innerHTML]="htmlsanitizado" class="nunito-medium bodyplan"></div>
    </div>
    <hr>

    <div class="expand-container" *ngIf="showExpandButton && planData.length > 0">
      <button (click)="toggleExpand()" class="expand-button">
        {{ expanded ? 'ver -' : 'ver +' }}
      </button>
    </div>

  </div>
</div>
<div style="position: relative;  width: 100%;" class="mob">

  <!-- Vista previa -->
  <div style="position: relative;">
    <!-- <div (click)="expand()"  class="pointer" [innerHTML]="html" ></div> -->
    <div class="pointer div-img-expand">
      <div [innerHTML]="image" *ngIf="image"></div>
      <img src="./assets/img/continua-fichas_mobile.png" *ngIf="!image" style="width: 100%;">
    </div>
    <!-- <button (click)="expand()" class="expand-btn" aria-label="Expandir contenido">
      <img src="./assets/img/arrows_output.png" alt="expandir">
    </button> -->
  </div>

  <!-- Modal de pantalla completa -->
  <div class="html-modal" *ngIf="isModalOpen">
    <div class="html-content-wrapper" (wheel)="zoom($event)" (mousedown)="startDrag($event)"
      (mousemove)="onDrag($event)" (mouseup)="endDrag()" (mouseleave)="endDrag()" [ngStyle]="{
     'transform': 'scale(' + scale + ') translate(' + translateX + 'px,' + translateY + 'px)',
     'cursor': isDragging ? 'grabbing' : 'grab'
   }">
      <div [innerHTML]="html"></div>
    </div>

    <button class="close-btn2" (click)="close(); $event.stopPropagation()">x</button>
  </div>
</div>